import styled from '@emotion/styled';

export const Wrapper = styled.div({
  height: '100vh',
  display: 'grid',
  placeContent: 'center',
});
